import * as React from 'react';
import styled from '@emotion/styled';
import { observer } from 'src/utils/mobx-react';

interface PropsType {
    className?: string;
    onClick?: () => void;
}

const SvgElement = styled('svg', { label: 'SvgElement' })`
    height: auto;
`;

export const HorseIcon = observer('HorseIcon', ({ className, onClick }: PropsType): JSX.Element => {
    return (
        <SvgElement
            xmlns='http://www.w3.org/2000/svg'
            width='16'
            height='16'
            viewBox='0 0 16 16'
            fill='none'
            className={className}
            onClick={onClick}
        >
            <mask
                id='horseMask'
                width='14'
                height='14'
                x='1'
                y='1'
                maskUnits='userSpaceOnUse'
                style={{ maskType: 'alpha' }}
            >
                <path
                    fill='#142448'
                    d='M14.61 10.057 12.79 5.78a3.22 3.22 0 0 0-2.423-2.063c.47-.276 1.206-.935.891-2.143a.24.24 0 0 0-.312-.159L5.68 3.385c-3.412 1.227-4.347 4.235-4.347 8.4v2.114c0 .46.373.833.834.833h6.15a.832.832 0 0 0 .746-1.206L8 11.4v-.019a3.33 3.33 0 0 1-2.716-1.812.21.21 0 0 1 .042-.242l.315-.315a.208.208 0 0 1 .336.062 2.49 2.49 0 0 0 2.276 1.495c.448 0 .86-.133 1.219-.344l1.197 1.664a.83.83 0 0 0 .678.347h1.31a.83.83 0 0 0 .588-.245l1.18-1.037a.85.85 0 0 0 .185-.896M9.875 7.232a.624.624 0 0 1-.625-.625c0-.347.279-.625.625-.625.347 0 .625.278.625.625a.624.624 0 0 1-.625.625'
                />
            </mask>
            <g mask='url(#horseMask)'>
                <path
                    fill='#0b1627'
                    fillOpacity='.64'
                    d='M0 0h16v16H0z'
                />
            </g>
        </SvgElement>
    );
});
